import React from 'react';

const ToggleSideStream = props => {
    const {event, visible, onClick} = props;

    return (
        <div
            className={['ToggleSideStream', visible ? 'visible' : 'hidden'].join(' ')}
            onClick={onClick}
            style={{
                backgroundColor: event.settings.primary_color,
            }}
        />
    );
};

export default ToggleSideStream;
